var render = function render(){var _vm=this,_c=_vm._self._c;return _c('RowFormWrapper',{attrs:{"title":_vm.column.title,"mandatory":_vm.column.mandatory,"description":_vm.column.description}},[_c('NcCheckboxRadioSwitch',{attrs:{"type":"switch","checked":_vm.localValue,"data-cy":"selectionCheckFormSwitch"},on:{"update:checked":function($event){_vm.localValue=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }